import { useTranslation } from 'react-i18next';

import { PassesSearchForm } from '@frontend/features/travel-services/components/PassesSearchForm';
import { TravelServicesPage } from '@frontend/features/travel-services/components/TravelServicesPage';
import { useSearchFormKey } from '@frontend/features/travel-services/useSearchUrlState';

/** Buscador de pases de tren (vertical passes de Rutero). */
export const Passes = () => {
  const { t } = useTranslation();
  // Aplicar una búsqueda reciente remonta el buscador: si no, los campos
  // (que se llenan al montar) quedarían vacíos bajo los resultados nuevos.
  const formKey = useSearchFormKey();

  return (
    <TravelServicesPage
      title={t('common.nav.passes')}
      intro={t('travelServices.passesIntro')}
    >
      <PassesSearchForm key={formKey} />
    </TravelServicesPage>
  );
};

export default Passes;
